@if( approvalMenuItems()?.length ) {
  <div class="tw-flex-initial tw-justify-self-end tw-self-center tw-flex tw-items-center tw-gap-2">
    <ng-content select=".approval-status"></ng-content>
    <app-approval-menu
      class="tw-justify-self-end tw-self-center"
      [approvalMenuItems]="approvalMenuItems()"
    ></app-approval-menu>
  </div>
} @else {
  <!-- If no options: display content outlet for offer link -->
  <ng-content></ng-content>
}
